import { useAuth0 } from '@auth0/auth0-react';

// A manage.rapnet permission, or a list of them of which any one will do.
export type BackofficePermission = string | string[];

// The signed-in user's manage.rapnet permissions: the "backoffice" permissions of the token, which
// the BFF checks on its side too.
export const useBackofficePermissions = (): string[] => {
  const { user } = useAuth0();
  return user?.['http://rapaport.com/permissions']?.backoffice ?? [];
};

// Whether the permissions include the one asked for, or any one of a list.
export const hasBackofficePermission = (permissions: string[], permission: BackofficePermission) =>
  (Array.isArray(permission) ? permission : [permission]).some(p => permissions.includes(p));

// Whether the signed-in user has a manage.rapnet permission, or any one of a list.
export const useBackofficePermission = (permission: BackofficePermission) =>
  hasBackofficePermission(useBackofficePermissions(), permission);
